import type { FaireProductEntity } from "../../entity_types/product";

export const p_kznbxyeray: FaireProductEntity = {
  token: "p_kznbxyeray",
  type: "product",
  name: 'Classic Watering Can-Green-9.5"H(66oz)',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/391d1645c7319f8b1172595b8131290652bf91002b9a9d618736df566b59194a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8806cadb89a76739959e57207639882736ab6fb72831ee5de614db15d83f3701.jpeg",
    "https://cdn.faire.com/fastly/9dffe015e5847cb1cb963b8c75f77438198938798f7f5775c35b2af052fa4f5c.jpeg",
    "https://cdn.faire.com/fastly/01602a69f5da2937fe25f0c607be58aaa16979d1986aa964f871b84589206026.jpeg",
  ],
  priceDollars: 25,
  description:
    "Water your plants in timeless style with this vintage-inspired Classic Watering Can. With its classic silhouette, fluted detailing, and rich forest-green finish, this piece effortlessly blends rustic appeal with everyday practicality.",
  tags: [],
  msrpDollars: 50,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:13.896Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
